import React, { Component, ReactNode } from 'react';
import Logo from './Logo';

import styles from './styles.less';

interface Props {
	children: ReactNode | null;
	panel: ReactNode | null;
	bottomPanel: ReactNode | null;
	innerContainerStyle?: React.CSSProperties;
}

export default class Navigation extends Component<Props> {
	static defaultProps = {
		children: null,
		panel: null,
		bottomPanel: null,
	};

	render() {
		const { children, innerContainerStyle, panel, bottomPanel } = this.props;

		return (
			<header className={bottomPanel ? styles.headerWithBottomPanel : styles.header}>
				<div className={styles.in} style={innerContainerStyle}>
					<div className={styles.headerContent}>
						<div className={styles.navigation}>
							<Logo />
							<ul className={styles.navigationList}>{children}</ul>
						</div>
						<div className={styles.headerUser}>{panel}</div>
					</div>
				</div>
				{bottomPanel}
			</header>
		);
	}
}
